import React from "react";
import { FileText, Sparkles } from "lucide-react";
import { fmtMoney } from "@/lib/api";

const FIELD_LABELS = { vendor: "Vendor / store", date: "Date", amount: "Amount" };

const Corrections = ({ items }) => (
  <div className="space-y-1">
    {items.map((c, i) => (
      <div key={i} className="text-xs bg-amber-50 border border-amber-200 rounded-sm px-2 py-1">
        <span className="font-semibold text-amber-800">{FIELD_LABELS[c.field] || c.field} fixed:</span>{" "}
        <span className="line-through text-muted-foreground">{c.worker_value || "—"}</span>
        {" → "}
        <span className="font-semibold">{c.ai_value}</span>
      </div>
    ))}
  </div>
);

const Products = ({ items }) => (
  <div className="border border-border rounded-sm overflow-hidden bg-white">
    <div className="grid grid-cols-12 px-2 py-1 text-[10px] uppercase tracking-wider text-muted-foreground bg-secondary/50">
      <span className="col-span-7">Product</span>
      <span className="col-span-2 text-right">Qty</span>
      <span className="col-span-3 text-right">Price</span>
    </div>
    {items.map((it, i) => (
      <div key={i} className="grid grid-cols-12 px-2 py-1 text-xs border-t border-border">
        <span className="col-span-7 break-words">
          {it.name}
          {it.vendor && <span className="block text-[10px] text-muted-foreground">{it.vendor}</span>}
        </span>
        <span className="col-span-2 text-right">{it.qty}</span>
        <span className="col-span-3 text-right">{it.line_total != null ? fmtMoney(it.line_total) : "—"}</span>
      </div>
    ))}
  </div>
);

// AI receipt breakdown: what the AI fixed, the products it read, the receipt total, then the receipt itself.
export const AiBreakdownPanel = ({ audit, hasReceipt, onViewReceipt, testId }) => {
  if (audit && audit.status && audit.status !== "done") audit = null;
  if (!audit && !hasReceipt) return null;
  return (
    <div className="border border-violet-200 bg-violet-50/40 rounded-sm p-2.5 space-y-2 text-left" data-testid={testId}>
      <p className="text-[10px] uppercase tracking-wider text-violet-800 font-semibold flex items-center gap-1"><Sparkles className="w-3 h-3" /> AI receipt breakdown</p>
      {(audit?.corrections || []).length > 0 && <Corrections items={audit.corrections} />}
      {audit?.receipt_total != null && (
        <p className="text-xs">{(audit.receipts_read || 1) > 1 ? `Receipts total (${audit.receipts_read} receipts):` : "Receipt total:"} <span className="font-semibold">{fmtMoney(audit.receipt_total)}</span></p>
      )}
      {(audit?.line_items || []).length > 0 && <Products items={audit.line_items} />}
      {!audit && <p className="text-xs text-muted-foreground">This charge hasn&apos;t been scanned yet.</p>}
      {hasReceipt && (
        <button type="button" onClick={onViewReceipt}
          className="inline-flex items-center gap-1 text-[11px] font-semibold text-emerald-800 underline underline-offset-2"
          data-testid={`${testId}-view-receipt`}>
          <FileText className="w-3 h-3" /> View receipt
        </button>
      )}
    </div>
  );
};
